// 单据类型
export const BILLTYPE = {
  "10": "成品采购",
  "11": "补件采购",
  "12": "定制采购",
  "13": "小商品采购",
  "14": "海外采购",
  "15": "代发备货采购",
  "101": "原材料",
  "105": "委外加工-成品",
  "106": "委外加工-零部件",
  "108": "零部件采购"
}
// 单据状态
export const RECEIPTS_STATUS = {
  "10": "创建",
  "15": "审核中",
  "20": "已审核",
  "25": "增货-待审",
  "99": "已作废",
  create: {
    key: 10,
    label: '创建'
  },
  review: {
    key: 15,
    label: '审核中'
  },
  reviewed: {
    key: 20,
    label: '已审核'
  },
  addProduct: {
    key: 25,
    label: '增货-待审'
  },
  cancel: {
    key: 99,
    label: '已作废'
  },
  show: {
    key: 98,
    label: '显示增货单'
  }
}

// 占用库位
export const LOCATION_OCCUPANCY_STATUS = {
  "0": "-",
  "10": "成功",
  "15": "失败"
}
// 完成状态
export const COMPLETE_STATUS = {
  "0": "-",
  "10": "已推送",
  "15": "安排中",
  "20": "已关闭"
}
// 完成状态
export const COMPLETE_STATUS_LIST = [
  {
    key: 0,
    label: '初始'
  },
  {
    key: 10,
    label: '已推送'
  },
  {
    key: 15,
    label: '安排中'
  },
  {
    key: 20,
    label: '已关闭'
  }
]
// 是或否
export const YES_OR_NO = {
  1: '是',
  0: '否'
}
// 是否
export const TRUE_IS = [
  {
    key: 1,
    label: '是'
  },
  {
    key: 0,
    label: '否'
  }
]
// 独占单工厂
export const FACTORY_IS = [
  {
    key: 1,
    label: '独占'
  },
  {
    key: 0,
    label: '非独占'
  }
]
// 是否独占（内外部）
export const INNER_OUT = [
  {
    key: 10,
    label: '内部独供'
  },
  {
    key: 15,
    label: '外部独供'
  },
  {
    key: 0,
    label: '非独供'
  }
]
// 大于小于
export const RANGE_LIST = [
  {
    key: 'eq',
    label: '等于'
  },
  {
    key: 'lt',
    label: '小于'
  },
  {
    key: 'le',
    label: '小于等于'
  },
  {
    key: 'gt',
    label: '大于'
  },
  {
    key: 'ge',
    label: '大于等于'
  }
]
// 单据类型
export const BILL_TYPE_LIST = [
  {
    key: 10,
    label: '成品采购'
  },
  {
    key: 11,
    label: '补件采购'
  },
  {
    key: 12,
    label: '定制采购'
  },
  {
    key: 13,
    label: '小商品采购'
  },
  {
    key: 14,
    label: '海外采购'
  },
  {
    key: 15,
    label: '代发备货采购'
  },
  {
    key: 101,
    label: '原材料'
  },
  {
    key: 105,
    label: '委外加工-成品'
  },
  {
    key: 106,
    label: '委外加工-零部件'
  },
  {
    key: 108,
    label: '零部件采购'
  }
]
// 搜索单据状态，只显示两个状态
export const SEARCH_STATUS_LIST = [
  {
    key: 20,
    label: '已审核－全部'
  },
  {
    key: 25,
    label: '增货－待审核'
  }
]

export const INTERNAL_EXCLUSIVE_MAP = {
  10: '内部独占',
  15: '外部独占',
  0: '非独占'
}

export const COMPLETE_STATUS_MAP = {
  0: '初始',
  10: '已推送',
  15: '安排中',
  20: '已关闭'
}

export const IMPORT_STATE_MAP = {
  PENDING: 'pending',
  LOADING: 'loading',
  FINISHED: 'finished',
  FAIL: 'fail'
}

// 导入收货计划表格列
export const RECEIPT_PLAN_RESULT_COLUMNS = [
  {
    title: ' ',
    dataIndex: 'importState',
    scopedSlots: { customRender: 'importState' },
    fixed: 'left',
    align: 'center',
    width: 40
  },
  {
    dataIndex: 'factoryName',
    title: '供应商',
    width: 250
  },
  {
    dataIndex: 'billNo',
    title: '计划单号',
    width: 200
  },
  {
    dataIndex: 'parentBillNo',
    title: '增货计划单',
    width: 150
  },
  {
    dataIndex: 'parentReceiptBillNo',
    title: '增货-送货单',
    width: 150
  },
  {
    dataIndex: 'status',
    title: '单据状态',
    width: 100
  },
  {
    dataIndex: 'completeStatus',
    title: '完成状态',
    width: 100
  },
  {
    dataIndex: 'dischargeIs',
    title: '是否仓库卸货',
    width: 150
  },
  {
    dataIndex: 'inspectionAtWarehouse',
    title: '是否到仓验货',
    width: 150
  },
  {
    dataIndex: 'newProductIs',
    title: '是否新品',
    width: 150
  },
  {
    dataIndex: 'materialNo',
    title: '物料编码',
    width: 150,
    ellipsis: true
  },
  {
    dataIndex: 'materialName',
    title: '物料名称',
    width: 150,
    ellipsis: true
  },
  {
    dataIndex: 'materialSpec',
    title: '规格描述',
    width: 150,
    ellipsis: true
  },
  {
    dataIndex: 'requireDeliveryDay',
    title: '要求到货日期',
    width: 130
  },
  {
    dataIndex: 'requireDeliveryQuantity',
    title: '要求到仓数',
    width: 110
  },
  {
    dataIndex: 'internalExclusiveIs',
    title: '是否独占(内外部)',
    width: 150
  },
  {
    dataIndex: 'supplierExclusiveIs',
    title: '是否独占(单工厂)',
    width: 150
  },
  {
    dataIndex: 'supplementQuantity',
    title: '增货数量',
    width: 100
  },
  {
    dataIndex: 'auditQuantity',
    title: '审核数量',
    width: 150
  },
  {
    dataIndex: 'arrangeVolume',
    title: '安排体积',
    width: 100
  },
  {
    dataIndex: 'cancelQuantity',
    title: '取消数量',
    width: 100
  },
  {
    dataIndex: 'surplusInStockQuantity',
    title: '剩余入库数量',
    width: 150
  },
  {
    dataIndex: 'warehouseName',
    title: '入库仓库',
    width: 150
  },
  {
    dataIndex: 'factoryWarehouseName',
    title: '供应商仓库',
    width: 120
  },
  {
    dataIndex: 'presetLoadVolume',
    title: '预设装载体积',
    width: 150
  },
  {
    dataIndex: 'depositAreaName',
    title: '存放区域',
    width: 120
  },
  {
    dataIndex: 'locationQuantity',
    title: '库位数',
    width: 80
  },
  {
    dataIndex: 'qtyPerLocation',
    title: '标准库位套数',
    width: 150
  },
  {
    dataIndex: 'curOrderSatisfyRate',
    title: '当前订单满足率',
    width: 150
  },
  {
    dataIndex: 'sumOrderSatisfyRate',
    title: '累计安排订单满足率',
    width: 160
  },
  {
    dataIndex: 'inStockQuantity',
    title: '已入库数量',
    width: 100
  },
  {
    dataIndex: 'arrangeQuantity',
    title: '已安排数量',
    width: 100
  },
  {
    dataIndex: 'unArrangeQuantity',
    title: '未安排数量',
    width: 100
  },
  {
    dataIndex: 'entruckQuantity',
    title: '装车数量',
    width: 100
  },
  {
    dataIndex: 'curOverageQuantity',
    title: '本次超出数量',
    width: 120
  },
  {
    dataIndex: 'sumOverageQuantity',
    title: '累计超出数量',
    width: 120
  },
  {
    dataIndex: 'supplierPriorityLevel',
    title: '供应商入库优先级',
    width: 160
  }
]

// 计划单来源
export const CREATE_IS = {
    1: '自动',
    0: '手工'
  }

// 计划单来源
export const CREATE_IS_LIST = [
  {
    key: 1,
    label: '自动'
  },
  {
    key: 0,
    label: '手工'
  }
]
// 早晚班
export const MORNING_OR_EVENING = {
  1: '早班',
  0: '晚班'
}
// 早晚 班
export const MORNING_OR_EVENING_LIST = [
  {
    key: 1,
    label: '早班'
  },
  {
    key: 0,
    label: '晚班'
  }
]
